import { BookmarkCheckIcon, Loader2Icon } from 'lucide-react'

import { Button } from '@/components/ui/button'

/** Untrack confirmation content for tooltip, styled like TrackTagLoginPrompt. */
export const TrackTagUntrackConfirm = ({
  onConfirm,
  loading,
}: {
  onConfirm: () => Promise<void>
  loading: boolean
}) => (
  <div className="flex max-w-50 flex-col items-center gap-2 py-1 text-center text-balance">
    <div className="flex size-8 items-center justify-center rounded-lg bg-destructive/20 p-1.5">
      <BookmarkCheckIcon className="size-4 text-destructive" />
    </div>
    <p className="text-xs font-semibold text-foreground">
      Are you sure you want to untrack this bill?
    </p>
    <Button
      variant="outline"
      size="small"
      className="w-full text-xs"
      onClick={(e) => {
        e.stopPropagation()
        onConfirm()
      }}
      disabled={loading}
    >
      {loading ? (
        <Loader2Icon className="size-3.5 shrink-0 animate-spin" aria-label="Processing..." />
      ) : (
        'Yes, untrack'
      )}
    </Button>
  </div>
)
